export default __webpack_public_path__ + "static/media/learning.9e69d17b.png";